import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import useFetch from '../hooks/useFetch';
import Loader from './utils/Loader';
import Tooltip from './utils/Tooltip';

const CommuniCaptures = () => {

  const authState = useSelector(state => state.authReducer);
  const [communicaptures, setCommunicaptures] = useState([]);
  const [fetchData, { loading }] = useFetch();

  const fetchCommunicaptures = useCallback(() => {
    const config = { url: "/communicaptures", method: "get", headers: { Authorization: authState.token } };
    fetchData(config, { showSuccessToast: false }).then(data => setCommunicaptures(data.communicaptures));
  }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchCommunicaptures();
  }, [authState.isLoggedIn, fetchCommunicaptures]);


  const handleDelete = (id) => {
    const config = { url: `/communicaptures/${id}`, method: "delete", headers: { Authorization: authState.token } };
    fetchData(config).then(() => fetchCommunicaptures());
  }


  return (
    <>
      <div className="my-2 mx-auto max-w-[700px] py-4">
        {communicaptures.length !== 0 && <h2 className='my-2 ml-2 md:ml-0 text-white'>Your Communications ({communicaptures.length})</h2>}
        {loading ? (
          <Loader />
        ) : (
          <div>
            {communicaptures.length === 0 ? (

              <div className='w-[600px] h-[300px] flex items-center justify-center gap-4'>
                <span>No communicaptures found</span>
                <Link to="/communicaptures/add" className="bg-blue-500 text-white hover:bg-blue-600 font-medium rounded-md px-4 py-2">+ Add new communicapture </Link>
              </div>

            ) : (
              communicaptures.map((communicapture, index) => (
                <div key={communicapture._id} className='bg-white my-4 p-4 text-gray-600 rounded-md shadow-md'>
                  <div className='flex'>

                    <span className='font-medium'>Communicapture #{index + 1}</span>

                    <Tooltip text={"Edit this communicapture"} position={"top"}>
                      <Link to={`/communicaptures/${communicapture._id}`} className='ml-auto mr-2 text-green-600 cursor-pointer'>
                        <i className="fa-solid fa-pen"></i>
                      </Link>
                    </Tooltip>

                    <Tooltip text={"Delete this communicapture"} position={"top"}>
                      <span className='text-red-500 cursor-pointer' onClick={() => handleDelete(communicapture._id)}>
                        <i className="fa-solid fa-trash"></i>
                      </span>
                    </Tooltip>

                  </div>
                  <div className='whitespace-pre'>{communicapture.description}</div>
                </div>
              ))

            )}
          </div>
        )}
      </div>
    </>
  )

}

export default CommuniCaptures